import {
  ClassProvider,
  FactoryProvider,
  InjectionToken,
  PLATFORM_ID,
} from '@angular/core';
import { BrowserWindowReference } from './browser-window-reference';
import { windowFactory } from './window-factory';
import { WindowReference } from './window-reference';

export const WINDOW = new InjectionToken('WindowToken');

export const browserWindowProvider: ClassProvider = {
  provide: WindowReference,
  useClass: BrowserWindowReference,
};

export const windowProvider: FactoryProvider = {
  provide: WINDOW,
  useFactory: windowFactory,
  deps: [WindowReference, PLATFORM_ID],
};

export const WINDOW_PROVIDERS = [browserWindowProvider, windowProvider];
